import React from 'react';
import { Box } from '@mui/material';
import { renderArtifactIconSmall } from '../../utils/artifactIconUtils';
import { getColorForTipoArtefacto, getIconoForTipoArtefacto } from './DeviceTypeImage';

export interface DeviceTypeImageSmallProps {
  tipo_artefacto?: string | null;
  deviceIP?: string;
  isAdmin?: boolean;
  onDeviceClick?: (deviceIP: string) => void;
}

const DeviceTypeImageSmall: React.FC<DeviceTypeImageSmallProps> = ({
  tipo_artefacto,
  deviceIP,
  isAdmin,
  onDeviceClick,
}) => {
  const [, setMapTick] = React.useState(0);

  React.useEffect(() => {
    const onMapUpdate = () => setMapTick((n) => n + 1);
    window.addEventListener('tiposArtefactoMapUpdated', onMapUpdate);
    return () => window.removeEventListener('tiposArtefactoMapUpdated', onMapUpdate);
  }, []);

  const tipoArtefacto = tipo_artefacto?.trim() || '';
  const iconContent = tipoArtefacto
    ? renderArtifactIconSmall(
        getIconoForTipoArtefacto(tipoArtefacto),
        tipoArtefacto,
        getColorForTipoArtefacto(tipoArtefacto),
      )
    : null;

  return (
    <Box
      onClick={(e) => {
        e.stopPropagation();
        if (isAdmin && deviceIP && onDeviceClick) {
          onDeviceClick(deviceIP);
        }
      }}
      sx={{
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        overflow: 'hidden',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#1B1D21',
        cursor: isAdmin && deviceIP ? 'pointer' : 'default',
        flexShrink: 0,
      }}
    >
      {iconContent}
    </Box>
  );
};

export default DeviceTypeImageSmall;
